import store from "@/stores";
import Router from "@/routes";
import { checkAuthMemberLifeTime } from "@/helpers/authenticate";
import { ACT_FORCE_FRESH_AUTH_MEMBER } from "@/stores/modules/AuthMember/types";

export default function authMember({to, next}) {
  let isAuthMember = checkAuthMemberLifeTime();
  // not authenticated
  if (!isAuthMember) {
    let { path } = to
    // remove store
    store.dispatch(`AuthMember/${ACT_FORCE_FRESH_AUTH_MEMBER}`)
    setTimeout(() => {
      Router.push({ name: 'MemberLogin', query: { redirect: path } });
    },500)
  } else {
    // authenticate is TRUE
    if (to.name === 'MemberLogin') {
      return Router.push({ name: 'MemberEdit' });
    }
    return next();
  }
}
